import {
  SUBSCRIBE_REQUEST,
  SUBSCRIBE_SUCCESS,
  SUBSCRIBE_FAIL,
} from "../actions/types";

export const subscriptionReducer = (state = {}, action) => {
  console.log("subemail_____ reducer", action.payload);
  switch (action.type) {
    case SUBSCRIBE_REQUEST:
      console.log("reducer_ request");
      return { loading: true };
    case SUBSCRIBE_SUCCESS:
      console.log("reducer_ success");
      return { loading: false, success: true, message: action.payload };
    case SUBSCRIBE_FAIL:
      console.log("reducer_ fail", action.payload);
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
